import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import A from './components/A';
import css from './index.module.scss';
import ScrollMagicFn from '@/utils/ScrollMagic';

const Dynamic = dynamic(() => import('./indexDynamic'), { ssr: true });

export default function Teaser() {
    // 这一段必须要先于子组件触发
    if (typeof window !== 'undefined' && typeof ScrollMagic == 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    useEffect(() => {
        return () => {
            AniContainer?.destroy();
        };
    }, []);

    return (
        <div className={`delta-2-max-teaser ${css.d2xTeaser}`}>
            <A />
            <Dynamic />
            {/* 预热站点不展示导航栏 & popup css */}
            <style jsx global>
                {`
                    .product_naver {
                        display: none;
                    }
                    .ant-modal-root .ef-popup {
                        .ant-modal-content {
                            background-color: #fff;
                            padding: 0.4rem 0.28rem 0.4rem;
                            .ant-modal-close {
                                width: 0.28rem;
                                height: 0.28rem;
                                left: unset;
                                right: 0.12rem;
                                top: 0.12rem;
                                background: #999999;
                                transform: scale(1);
                                border-radius: 50%;

                                .ant-modal-close-x {
                                    width: 0.28rem;
                                    height: 0.28rem;
                                    font-size: 0.16rem;
                                    border: unset;
                                }
                            }
                            .ant-modal-body {
                                .popup-title {
                                    font-size: 0.32rem;
                                    text-align: center;
                                    color: #03060b;
                                    line-height: 0.4rem;
                                }
                                .popup-text {
                                    font-family: var(--font-family-SemiBold);
                                    color: #919191;
                                    text-align: center;
                                }
                                .popup-btn {
                                    margin-top: 0.6rem;
                                    width: 1.88rem;
                                    height: 0.48rem;
                                    background: #2164ff;
                                    border-radius: 0.06rem;
                                    font-size: 0.16rem;
                                    line-height: 0.25rem;
                                }
                            }
                        }
                    }
                `}
            </style>
        </div>
    );
}
